var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRdtScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.992 8.826a5.527 5.527 0 0 1 0-7.897L2.05 0a6.828 6.828 0 0 0 0 9.755l.942-.93z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.877 6.968a2.926 2.926 0 0 1 0-4.18l-.942-.93a4.227 4.227 0 0 0 0 6.039l.942-.93z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.026 2.065c0-.101.081-.183.182-.183h12.369a3.423 3.423 0 1 1 0 6.846H8.208a.183.183 0 0 1-.182-.182V2.065z",
    stroke: "currentColor",
    strokeWidth: 1.498
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.026 2.065c0-.101.081-.183.182-.183h12.369a3.423 3.423 0 1 1 0 6.846H8.208a.183.183 0 0 1-.182-.182V2.065z",
    stroke: "currentColor",
    strokeWidth: 1.498
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.718 16.336.74-.109-.74.109zm-1.116-7.608V7.98h-.867l.126.858.741-.109zm2.617 8.934-.016.748.016-.748zm1.887.041.016-.748-.016.748zm1.575-1.734.743-.088-.743.088zm-.86-7.25.743-.088-.084-.71-.713.051.054.747zm-3.362 7.508-1.116-7.608-1.482.218 1.116 7.607 1.482-.217zm.777.686a.803.803 0 0 1-.777-.686l-1.482.217a2.3 2.3 0 0 0 2.226 1.966l.033-1.497zm1.886.042-1.886-.042-.033 1.497 1.886.042.033-1.497zm.815-.898a.803.803 0 0 1-.815.898l-.033 1.497a2.3 2.3 0 0 0 2.335-2.571l-1.487.176zm-.86-7.25.86 7.25 1.487-.176-.86-7.25-1.487.176zm.69-.835a2.497 2.497 0 0 1-.194.007v1.498c.1 0 .201-.004.301-.01l-.107-1.495zm-.194.007h-4.97v1.498h4.97V7.979z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.396 8.728v.749h.917l-.183-.898-.734.149zm-.794 0v-.749h-.867l.126.858.741-.109zm.489 3.332v.749h.866l-.125-.858-.741.109zm-2.431-.453.727.18-.727-.18zm.618-2.509-.727-.179.727.18zm.227-.255-.261-.701.261.701zm.31-.115v-.749h-.135l-.126.047.261.702zm1.581 0 .734-.15-.122-.599h-.612v.749zm0-.749h-.794v1.498h.794V7.979zm-1.535.858.489 3.332 1.482-.218-.49-3.332-1.48.218zm1.23 2.474h-2.077v1.498h2.077V11.31zm-2.077 0c.25 0 .432.234.373.476l-1.454-.359a1.114 1.114 0 0 0 1.081 1.38v-1.497zm.373.476.618-2.51-1.454-.358-.618 2.51 1.454.358zm.618-2.51a.384.384 0 0 1-.239.268l-.522-1.403c-.345.128-.605.42-.693.777l1.454.358zm-.239.268.31-.115-.522-1.404-.31.116.522 1.403zm.05-.068h1.58V7.979h-1.58v1.498zm.846-.6 1.468-.298-1.467.298z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.498,
    d: "M10.965 1.882v6.846"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdtScanner);
export default __webpack_public_path__ + "static/media/rdt_scanner.259e8c963e3679719298c70abc72d8ba.svg";
export { ForwardRef as ReactComponent };